import { render, staticRenderFns } from "./costPerId.vue?vue&type=template&id=5a7c380c&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./costPerId.vue?vue&type=style&index=0&id=5a7c380c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c380c",
  null
  
)

export default component.exports